import React from "react";

export default function Layer0SolutionHero() {
  return (
    <>
      <section
        className="feature-section py_150"
        aria-label="empowering-projects-on-binance-smart-chain-"
        style={{
          backgroundImage:
            "url(assets/img/layer/empowering-projects-on-binance-smart-chain-.jpg",
          backgroundSize: "cover",
        }}
      >
        <div className="auto-container">
          <div className="row align-items-center pb_100">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div data-animation-box className="sec-title mb_55">
                <h2 className="text-white">
                  Empowering Projects on Binance Smart Chain (BSC)
                </h2>
                <p className="text-white py-3">
                  Xeer Technology offers tailored development solutions on
                  Binance Smart Chain, helping you launch high-performance DApps
                  and DeFi platforms with fast transactions and minimal fees.
                </p>
              </div>
              <div className="btn-box mt_40">
                <a href="/contact-us" className="theme-btn btn-one mr_20">
                  Hire Blockchain Expert
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column"></div>
          </div>
        </div>
      </section>
    </>
  );
}
